import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AdminModule } from './admin/admin.module';
import { UserModule } from './user/user.module';
import { authInterceptor } from './interceptors/auth.interceptor';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		SharedModule,
		NgxSpinnerModule,
		AdminModule,
		UserModule
	],
	providers: [provideHttpClient(withInterceptors([authInterceptor]))],
	bootstrap: [AppComponent]
})
export class AppModule {}
